module.exports = __webpack_public_path__ + "front/img/33_2.4d980314.png";